<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Form Date Errors
      </h2>
      <p class="tw-italic tw-text-gray-700">

      </p>
    </b-container>

    <b-table striped hover :fields="fields" :items="forms" :current-page="currentPage"
      :per-page="perPage">
      <template v-slot:cell(form_id)="data">
        <!-- Only show approve/decline buttons for new requests -->
        <b-link :href="data.item.case_link" target="_blank">{{ data.item.form_id }}</b-link>
      </template>

      <template v-slot:cell(dismissed)="data">
        <!-- Only show approve/decline buttons for new requests -->
        <b-button v-if="data.item.dismissed == false" @click="dismiss_form_date(data.index)" size="sm" variant="success" class="w-20"><i class="fa fa-check"></i></b-button>
      </template>
    </b-table>
    <b-row v-if="totalRows > perPage">
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "form_name" },
        { key: "form_id" },
        { key: "received_on", sortable: true },
        { key: "form_date", sortable: true },
        { key: "user_submitted" },
        { key: "village" },
        { key: "dismissed", label: "Dissmiss" }
      ],
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      forms: [],
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/form_dates/get_list").then(response => {
      that.forms = response.data;
      that.totalRows = response.data.length;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('formdateerrors', 
            ['getFormDateErrorCount', 'setFormDateErrorCount']),

    refreshSideNavCount(){
      this.getFormDateErrorCount().then((response) => {
                this.setFormDateErrorCount(response.data);
            });
    },
    dismiss_form_date: function(index){
      let that = this;
      HTTP.post("/kenya/form_date/"+that.forms[index].id+"/", {
        status: 'dismiss'
      }).then(() => {
          that.forms.splice(index, 1);
          that.refreshSideNavCount();
      });

    }
  }
};
</script>

<style>
</style>